BaseComponentView = require 'views/components/base'


module.exports = class SocialComponentView extends BaseComponentView
    __name__: 'SocialComponentView'
    className: 'component-editor social-component'
    template: require 'views/templates/components/social'

